import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuControlsContainer from 'components/atoms/Editors/EditorMenuControlsContainer/EditorMenuControlsContainer.styles';

const EditorMenuControlsContainer = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuControlsContainer');

  return <StyledEditorMenuControlsContainer ref={ref} {...innerProps} />
});

EditorMenuControlsContainer.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuControlsContainer;
